let service = function (
	$q,
	_
) {
	"ngInject";
	
	var service = this;

	this.options = function(brands) {
		var options = brands.filter(function(brand) {
			return brand.on;
		}).reduce(function(a,b) {
			return a.concat(b.products);
		},[]);

		return $q.resolve(options);
	};

	this.interface = function(brands, optionArr, allUids, process, bool) {

		var uids;
		var max = process?0:0;

		var loop = function(brands, uids) {
			brands.forEach((brand) => {
				if (bool) {
					brand.count = _.intersection(brand.products, uids).length;
					brand.enabled = brand.count > max;
				} else {
					brand.count = false;
					brand.enabled = true;
				}
				
			});
		}

		if (!_.isEmpty(optionArr)) {
			uids = optionArr.reduce(function(a, b) {
				return _.intersection(a, b);
			}, allUids);

			loop(brands, uids);
		} else {
			loop(brands, allUids);
		}
	};
}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/brand.service.js